import React from "react";
// Loader para indicadores
export var IndicatorLoader = function () { return (React.createElement("span", { className: "flex items-center justify-center text-lg" },
    React.createElement("svg", { className: "animate-spin h-5 w-5 mr-2 text-white", viewBox: "0 0 24 24" },
        React.createElement("circle", { className: "opacity-25", cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "4", fill: "none" }),
        React.createElement("path", { className: "opacity-75", fill: "currentColor", d: "M4 12a8 8 0 018-8v8z" })),
    "Processando...")); };
// Função para calcular diferença percentual
export function percentDiff(current, previous) {
    if (current == null || previous == null || previous === 0)
        return null;
    var diff = ((current - previous) / previous) * 100;
    return diff;
}
// Função para formatar números grandes (ex: 1.200.000 => 1,2M)
export function formatNumberShort(n) {
    if (n == null)
        return "";
    if (n >= 1e6)
        return (n / 1e6).toFixed(1).replace(".", ",") + "M";
    if (n >= 1e3)
        return (n / 1e3).toFixed(1).replace(".", ",") + "K";
    return n.toLocaleString("pt-BR");
}
// Função para formatar datas (YYYY-MM-DD para DD/MM/YYYY)
export function formatDateBR(dateStr) {
    if (!dateStr)
        return "";
    var _a = dateStr.split("-"), year = _a[0], month = _a[1], day = _a[2];
    return "".concat(day, "/").concat(month, "/").concat(year);
}
// Paleta de cores padrão para gráficos
export var chartColors = [
    "#3b82f6", "#22d3ee", "#f59e42", "#f43f5e", "#a78bfa", "#34d399", "#fde047", "#818cf8"
];
// Exemplo de função para gerar tooltip de KPI
export function kpiTooltip(label) {
    switch (label) {
        case "Investimento":
            return "Total investido no período selecionado.";
        case "Impressões":
            return "Quantidade de vezes que o anúncio foi exibido.";
        case "Pessoas alcançadas":
            return "Número de pessoas únicas que visualizaram o anúncio.";
        case "Frequência":
            return "Média de vezes que cada pessoa viu o anúncio.";
        default:
            return "";
    }
}
